import { isPlatformBrowser } from '@angular/common';
import { ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ScreenService } from '../shared/services/screen.service';
import { timer } from 'rxjs/internal/observable/timer';

export class AnimatedComponentOnScrollAndResize {
    public state = 'hide';
    public isLargeScreen: boolean;
    public isMediumScreen: boolean;
    public isMobileScreen: boolean;

    constructor(private elementRef: ElementRef,
                protected screenService: ScreenService,
                @Inject(PLATFORM_ID) protected platformId: Object,
                private allowHide: boolean = false,
                private initialDelay: number = 100) {
                    if (isPlatformBrowser(this.platformId)) {
                        const delay = timer(this.initialDelay);
                        const subscription = delay.subscribe(d => {
                            this.updateState();
                            if (subscription) {
                                subscription.unsubscribe();
                            }
                        });
                        this.updateScreenFields();
                    } else {
                        this.state = 'show';
                    }
                }

    @HostListener('window:scroll')
    checkScroll() {
        this.updateState();
    }

    @HostListener('window:resize')
    checkScreenSize() {
        this.updateScreenFields();
    }

    public hasScrolledPixels = (pixels: number): boolean => {
        return this.screenService.hasScrolledPixels(pixels);
    }

    protected updateState = (): void => {
        if (this.state === 'hide' || this.allowHide) {
            this.state = this.screenService.isInViewState(this.elementRef);
        }
    }

    protected updateScreenFields = (): void => {
        this.isLargeScreen = this.screenService.isLargeScreen();
        this.isMediumScreen = this.screenService.isMediumScreen();
        this.isMobileScreen = this.screenService.isMobileScreen();
    }
}
